import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IBillingBalance,
  IBillingDocument,
  IBillingAccount,
} from '@dch/billing-business-logic';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectCustomerAccount } from 'src/app/state/selectors/customer-account.selector';
import { filter, tap } from 'rxjs/operators';
import { EnvironmentService, TranslationService } from '@dch/ng-common';
import { OnDestroyHookDirective } from '../common/hooks';
import {
  BILL_OPTIONS_PAYMENT_FACILITIES_INFO,
  SETTINGS_PAGE_LOGIN_REQUIRED_TRANSLATION_KEY,
  SETTINGS_PAGE_TRANSLATION_KEY,
} from '../config/my-bill.constants';
import { getDeferralCardVariant } from '../services/utils.service';

@Component({
  selector: 'my-bill-options',
  templateUrl: './bill-options.component.html',
  standalone: false,
})
export class BillOptionsComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() billDocument: IBillingDocument;
  @Input() billingAccount: IBillingAccount;
  @Input() customerPaymentProfile: IBillingBalance['customerPaymentProfile'];

  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);

  get isDeferralCardVisible(): boolean {
    return (
      getDeferralCardVariant(
        this.customerPaymentProfile,
        this.billDocument.partialDeferralCheck
      ) !== '4'
    );
  }

  isSmoothAccess: boolean;
  isStaySignedIn: boolean;
  showModal = false;
  redirectLink: string;
  billingAccountNumber: string;
  documentReference: string;

  showDeferralOrNoDeferralReason: string;
  BILL_OPTIONS_PAYMENT_FACILITIES_INFO = BILL_OPTIONS_PAYMENT_FACILITIES_INFO;
  settingsLabel = '';

  constructor(
    private router: Router,
    private store: Store<ApplicationState>,
    private environmentService: EnvironmentService,
    private translationService: TranslationService
  ) {
    super();
  }

  ngOnInit() {
    this.showDeferralOrNoDeferralReason =
      this.billDocument.partialDeferralCheck.showDeferral === false
        ? `bills.options.noDeferralReason${this.billDocument.partialDeferralCheck.reason}`
        : 'bills.options.showDeferral';
    this.billingAccountNumber = this.billingAccount.accountNumber;
    this.documentReference = this.billDocument.reference;
    this.isSmoothAccess = this.environmentService.isSmoothAccess;
    this.getSelectedCustomerAccountStaySignedInStatus();
  }

  onPaymentFacilitiesInfoLinkClick() {
    this.router.navigate([BILL_OPTIONS_PAYMENT_FACILITIES_INFO]);
  }

  onSettingsLinkClick() {
    if (this.isSmoothAccess || this.isStaySignedIn) {
      this.redirectLink = this.translationService.getTranslatedValueFor(
        SETTINGS_PAGE_LOGIN_REQUIRED_TRANSLATION_KEY
      );
      this.showModal = true;
    } else {
      this.redirectLink = this.translationService.getTranslatedValueFor(
        SETTINGS_PAGE_TRANSLATION_KEY
      );
      window.location.href = this.redirectLink;
    }
  }

  onCancel() {
    this.showModal = false;
  }

  private getSelectedCustomerAccountStaySignedInStatus() {
    this.addSubscription(
      this.selectedCustomerAccount$
        .pipe(
          filter(
            (selectedCustomerAccount) => selectedCustomerAccount !== undefined
          ),
          tap((selectedCustomerAccount) => {
            this.isStaySignedIn = selectedCustomerAccount.staySignedIn ?? false;
            const resUserKey =
              selectedCustomerAccount.getSelectedCustomer().subsegment === 'RES'
                ? 'RES.'
                : '';
            this.settingsLabel = this.translationService.getTranslatedValueFor(
              `bills.options.${resUserKey}settingsLabel`
            );
          })
        )
        .subscribe()
    );
  }
}
